export default __webpack_public_path__ + "static/media/img_muslinTwoBunny_rg.c3ad16f0.jpg";